import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "corss-sell container" }

import CrossSaleContainer from "./crossSaleContainer.vue";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'confirmationPage',
  setup(__props) {


const route = useRoute();

// Get from URL first, then fall back to localStorage
const productID = (route.query.productID as string) || localStorage.getItem('productID') || "";
const orderID = (route.query.orderID as string) || localStorage.getItem('orderID') || "";


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CrossSaleContainer, {
      orderID: _unref(orderID),
      productID: _unref(productID)
    }, null, 8, ["orderID", "productID"])
  ]))
}
}

})